import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './../styles/dashboard.css';
import { getMatchById } from '../api/apiClient';

const ArticleImages = () => {
    const { id } = useParams();
    const [matchData, setMatchData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMatchData = async () => {
            try {
                const data = await getMatchById(id);
                const response = data.data
                // console.log(response)
                setMatchData(response);
                setError(null);
            } catch (err) {
                setError(err.message || 'Failed to fetch image');
            } finally {
                setIsLoading(false);
            }
        };

        fetchMatchData();
    }, [id]);

    if (isLoading) {
        return <div className="loading">Loading image...</div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    if (!matchData?.image_base64) {
        return <div className="error">No image found</div>;
    }

    return (
        <div className="image-container">
            <img 
                src={`data:image/png;base64,${matchData.image_base64}`}
                alt="Article match"
                style={{ maxWidth: '100%', height: 'auto' }}
            />
        </div>
    );
};

export default ArticleImages;
